import { makeStyles } from '@mui/styles';

export const useSalesOrderDetailsTabStyles = makeStyles((theme) => ({
  gridRow: {
    '& + &': {
      paddingTop: theme.spacing(1),
    },
  },
}));
